import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import "./CapitalStructure.style.css";

const CapitalStructure = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";

  // kolon başlıkları (tek kaynak – hem masaüstü, hem mobilde td::before buradan beslenir)
  const COLS = {
    name:   { tr: "Ortağın Adı-Soyadı/Ticaret Ünvanı", en: "Shareholder / Trade Name" },
    amt:    { tr: "Sermayedeki Payı (TL)",               en: "Stake in Capital (TRY)" },
    capPct: { tr: "Sermayedeki Payı (%)",                en: "Stake (%)" },
    votePct:{ tr: "Oy Hakkı (%)",                  en: "Voting Right (%)" },
  };

  const dataLabelForName = (cellText) => {
    const isTotal = cellText === "TOPLAM" || cellText === "TOTAL";
    return isTotal ? undefined : COLS.name[L];
  };

  // örnek veri — diziye istediğin kadar satır ekle
  const groups = [
    {
      holder: { tr: "Cevher International B.V.", en: "Cevher International B.V." },
      lines: [
        { amt: "120.000.000", capPct: "40", votePct: "76,92" },
        { amt: "180.000.000", capPct: "60", votePct: "23,08" }
      ]
    }
    // başka ortaklar eklenecekse aynı formatta ekleyebilirsin
    // { holder: { tr: "Başka Ortak", en: "Another Shareholder" }, lines: [ ... ] }
  ];
  const total = { amt: "300.000.000", capPct: "100", votePct: "100" };
  const TOTAL_TEXT = L === "tr" ? "TOPLAM" : "TOTAL";
  return (
    <div>
      <Meta
        title={t("capital-structure")}
        description={t("capital-structure")}
        lang={lang}
      />
      <Navbar />

      <div className="c-wrapper">
        {/* Hero */}
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("capital-structure")}
              </h1>
            </div>
          </div>
        </div>

        {/* İçerik */}
        <div className="po-container">
          <InvestorSidebar />

          <main className="capr-content">
            <section className="capr-card">
              <table className="capr-table" role="table">
                <colgroup>
                  <col className="col-name" />
                  <col className="col-amt" />
                  <col className="col-cap" />
                  <col className="col-vote" />
                </colgroup>

                <thead>
                  <tr>
                    <th scope="col">{COLS.name[L]}</th>
                    <th scope="col">{COLS.amt[L]}</th>
                    <th scope="col">{COLS.capPct[L]}</th>
                    <th scope="col">{COLS.votePct[L]}</th>
                  </tr>
                </thead>

                <tbody>
                  {groups.map((g, gi) =>
                    g.lines.map((line, li) => {
                      const holderText = g.holder[L] || g.holder.en;
                      return (
                        <tr key={`${gi}-${li}`}>
                          {li === 0 && (
                            <td
                              className="cell-name"
                              rowSpan={g.lines.length}
                              data-label={dataLabelForName(holderText)}
                            >
                              {holderText}
                            </td>
                          )}
                          <td className="cell-num" data-label={COLS.amt[L]}>
                            {line.amt}
                          </td>
                          <td className="cell-num" data-label={COLS.capPct[L]}>
                            {line.capPct}
                          </td>
                          <td className="cell-num" data-label={COLS.votePct[L]}>
                            {line.votePct}
                          </td>
                        </tr>
                      );
                    })
                  )}

                  {/* TOPLAM satırı: name için data-label VERME! */}
                  <tr className="row-total">
                    <td className="cell-name" data-label={dataLabelForName(TOTAL_TEXT)}>
                      {TOTAL_TEXT}
                    </td>
                    <td className="cell-num" data-label={COLS.amt[L]}>
                      {total.amt}
                    </td>
                    <td className="cell-num" data-label={COLS.capPct[L]}>
                      {total.capPct}
                    </td>
                    <td className="cell-num" data-label={COLS.votePct[L]}>
                      {total.votePct}
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default CapitalStructure;
